"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Details = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _baseReactComponents = require("@navinc/base-react-components");

var _styles = require("./styles");

var _qualifiers = _interopRequireDefault(require("./qualifiers"));

var _additionalDetails = _interopRequireDefault(require("./additional-details"));

var _offerLinkAttributes = require("../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

var Details = function Details(_ref) {
  var loanOffer = _ref.loanOffer,
      shouldShowDetails = _ref.shouldShowDetails,
      isPersonal = _ref.isPersonal,
      _ref$trackDetails = _ref.trackDetails,
      trackDetails = _ref$trackDetails === void 0 ? function () {} : _ref$trackDetails,
      scrollAndToggle = _ref.scrollAndToggle,
      onApplyNow = _ref.onApplyNow;

  var handleDetailsBottomClick = function handleDetailsBottomClick() {
    trackDetails();
    scrollAndToggle();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailsWrapper, {
      "data-testid": "loancard:details",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BasedInfoText, {
        size: "xs",
        shouldScaleFont: true,
        children: ["Based on your ", isPersonal ? '' : 'business', " profile, here is how you match up with this financing option."]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_qualifiers["default"], {
        loanOffer: loanOffer
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_additionalDetails["default"], {
        loanOffer: loanOffer
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubTitle, {
        light: true,
        bold: true,
        children: "Details"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoanDescription, {
        light: true,
        size: "xs",
        shouldScaleFont: true,
        children: (0, _lodash["default"])(loanOffer, 'description', '')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubTitle, {
          light: true,
          bold: true,
          children: "Nav's Verdict"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BottomLine, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            size: "sm",
            children: (0, _lodash["default"])(loanOffer, 'navEditorial.summary', '')
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FlexDiv, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ApplyButton, Object.assign({
        rel: "noopener noreferrer",
        target: "_blank",
        size: "large"
      }, (0, _offerLinkAttributes.offerLinkAttributes)((0, _lodash["default"])(loanOffer, 'applyUrl', '')), !!onApplyNow && {
        onClick: function onClick() {
          return onApplyNow(loanOffer);
        }
      }, {
        children: "Apply now"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CardDetailsBottom, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BottomDetailsLink, {
          onClick: handleDetailsBottomClick,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
            light: true,
            shouldScaleFont: true,
            size: "xs",
            children: shouldShowDetails ? 'Hide details' : 'See details'
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Chevron, {
            shouldShowDetails: shouldShowDetails,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
              name: "actions/carrot-up",
              color: _baseReactComponents.theme.neutral400
            })
          })]
        })
      })]
    })]
  });
};

exports.Details = Details;
var _default = Details;
exports["default"] = _default;
//# sourceMappingURL=details.js.map